import { _teamSettingsService } from '../../../core/services/team-settings.service';

export const isUnifiedViewEnabled = () => !!_teamSettingsService?.isUnifiedPipelineViewEnabled();
export const isH2OEnabled = () => !!_teamSettingsService?.isH2OEnabled();
